import { createContext } from 'react';

const InitiatedFlowDispatchContext = createContext();

export default InitiatedFlowDispatchContext;
